/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_FinalistInputs */



/**
* | output |
* | --- |
* | "Finalist" |
*
* @param {Tournament_FinalistInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_finalist = /** @type {((inputs?: Tournament_FinalistInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_FinalistInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finaliste")
	if (locale === "es") return /** @type {LocalizedString} */ ("Finalista")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finalista")
	if (locale === "it") return /** @type {LocalizedString} */ ("Finalista")
	return /** @type {LocalizedString} */ ("Finalist")
});